import { DateTime } from '@ksyos/date-time';
import { REGISTRATION_CODE_EXPIRATION_DAYS } from '../../../../common/practitionerDomain';
import { translateKey } from '../../../translate';
import { Component } from '../../elements/Component';
import { NullableFormattedDate } from '../../elements/NullableFormattedDate';
import { NullableFormattedTime } from '../../elements/NullableFormattedTime';

interface IRegistrationCodeProps {
    practitioner?: {
        isRegistered: boolean;
        registrationCode: string | null;
        registrationCodeGeneratedDatetime: string | null;
        registrationDate: string | null;
    };
}

export class RegistrationCode extends Component<IRegistrationCodeProps, {}> {
    public render() {
        if (!this.props.practitioner) {
            return null;
        }

        if (this.props.practitioner.isRegistered) {
            return (
                <span>
                    {translateKey('practitioner.registeredOn')}:{' '}
                    <NullableFormattedDate value={this.props.practitioner.registrationDate} />
                </span>
            );
        } else if (this.props.practitioner.registrationCodeGeneratedDatetime !== null) {
            const expirationDateTime = DateTime.from(this.props.practitioner.registrationCodeGeneratedDatetime).add(
                REGISTRATION_CODE_EXPIRATION_DAYS,
                'days'
            );

            if (expirationDateTime.isAfter(DateTime.now())) {
                return (
                    <span>
                        {translateKey('practitioner.theRegistrationCodeIs')}:{' '}
                        <b>
                            {this.props.practitioner.registrationCode &&
                                this.props.practitioner.registrationCode.replace(/(...)(?=...)/g, '$1 ')}
                        </b>
                        . {translateKey('practitioner.expiresOn')}:{' '}
                        <NullableFormattedDate value={expirationDateTime.toDate()} />{' '}
                        <NullableFormattedTime value={expirationDateTime.toDate()} />.
                    </span>
                );
            } else {
                return <span>{translateKey('practitioner.theRegistrationCodeIsExpired')}</span>;
            }
        } else {
            return <span>{translateKey('practitioner.unregistered')}</span>;
        }
    }
}
